var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9994 41.2219V47.9981H0V41.2219C0 32.0324 7.62538 24.5586 16.9977 24.5586H23.0017C32.3756 24.5586 39.9994 32.0324 39.9994 41.2219Z",
    fill: "#7CC4FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2998 11.7008C31.2998 18.1518 26.2328 23.4 20.0034 23.4C19.9632 23.4 19.9213 23.4 19.881 23.3984C13.708 23.3306 8.70703 18.1092 8.70703 11.7008C8.70703 5.29085 13.708 0.0694506 19.881 0.00157875C19.9213 3.37221e-07 19.9632 0 20.0034 0C26.2328 0 31.2998 5.24823 31.2998 11.7008Z",
    fill: "#7CC4FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 23.4C19.961 23.4 19.9192 23.4 19.8789 23.3984V0.00157875C19.9192 3.37221e-07 19.961 0 20.0013 0C26.2307 0 31.2976 5.24823 31.2976 11.7008C31.2976 18.1518 26.2307 23.4 20.0013 23.4Z",
    fill: "#47A3F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 41.2219V47.9981H19.8789V24.5586H23.0025C32.3764 24.5586 40.0002 32.0324 40.0002 41.2219Z",
    fill: "#47A3F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person_icon.a2903c8fc9d62b1f6c7073764f6b61d0.svg";
export { ForwardRef as ReactComponent };